module.exports = __webpack_public_path__ + "img/handshake.1aba952b.svg";